import { RM04_02 } from "./RM04_02";

export const RM04_01 = {
  selectedValueColumn: "ItemCode",
  selectedTitle: "Region",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "Region",
        binding: {
          data: {
            columns: [
              {
                name: "Region",
                columnName: "RegionName",
                width: "450px",
                align: "left",
                sortable: true,
              },
              {
                name: "Number Of Branches",
                columnName: "NumberOfBranches",
                width: "350px",
                align: "center",
                sortable: true,
              },
            ],
            title: "RegionName",
            endpoint: "SFE_RM04.1",
            parameters: [
              { key: "CycleCode", value: "CP1" },
              { key: "CycleYear", value: "2026" },
              { key: "RegionCode", value: "" },
              { key: "ItemCode", value: "" },
            ],
          },
          context: {
            point: {
              onClick: RM04_02,
            },
          },
        },
      },
    },
  ],
};
